/**
 * TapsUK Optimized Carousel Logic
 * Initialized via requestIdleCallback to reduce Main Thread blocking.
 */
function initTapsCarousel(sectionId, settings) {
    const root = document.getElementById(sectionId);
    if (!root) return;

    const track = root.querySelector('.cc-track');
    const slides = Array.from(root.querySelectorAll('.cc-slide'));
    const dots = Array.from(root.querySelectorAll('.cc-dot'));
    const prevBtn = root.querySelector('.cc-prev');
    const nextBtn = root.querySelector('.cc-next');

    const count = slides.length;
    if (!track || !count) return;

    let index = 0;
    let timer = null;
    let startX = null, startY = null, dragging = false;
    const SWIPE_THRESHOLD = 40;

    // Set transition speed from settings
    track.style.setProperty('--speed', (settings.speed || 600) + 'ms');

    function update() {
        track.style.transform = `translateX(${-100 * index}%)`;
        slides.forEach((s, i) => s.toggleAttribute('aria-current', i === index));
        dots.forEach((d, i) => d.setAttribute('aria-pressed', i === index ? 'true' : 'false'));
    }

    function step(dir) {
        index = (index + dir + count) % count;
        update();
    }

    function play() {
        if (!settings.autoplay || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        stop();
        timer = window.setInterval(() => step(1), settings.delay || 5000);
    }

    function stop() {
        if (timer) { window.clearInterval(timer); timer = null; }
    }

    // Event Listeners
    root.addEventListener('mouseenter', stop, { passive: true });
    root.addEventListener('mouseleave', play, { passive: true });
    if (prevBtn) prevBtn.addEventListener('click', (e) => { e.preventDefault(); step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', (e) => { e.preventDefault(); step(1); });

    dots.forEach((btn, i) => {
        btn.addEventListener('click', (e) => { e.preventDefault(); index = i; update(); });
    });

    // Touch/Pointer Logic
    const viewport = root.querySelector('.cc-viewport');
    if (viewport) {
        viewport.addEventListener('pointerdown', (e) => {
            if (e.button !== 0) return;
            startX = e.clientX; startY = e.clientY; stop();
        });
        viewport.addEventListener('pointerup', (e) => {
            if (startX !== null) {
                const dx = e.clientX - startX;
                if (Math.abs(dx) > SWIPE_THRESHOLD) step(dx < 0 ? 1 : -1);
            }
            startX = null; play();
        });
    }

    update();
    play();
}